import {TrailRating} from "types/TrailRating";
import {dateTime} from "services/date";

/**
 * Transform the given trailRating by deserializing object properties
 *
 * @internal
 * @param trailRating
 */
export default function deserializeTrailRating(trailRating: any): TrailRating {
    trailRating.created_at = dateTime(trailRating.created_at)
    trailRating.updated_at = dateTime(trailRating.updated_at)

    return trailRating;
}